import { type StopLegPair, WorkflowType } from 'screens/TripDetails/TripDetails.types'

export const processStopLegPairsForBulkUpdates = (allStopLegPairs: StopLegPair[], stopType: 'PUP' | 'DEL' | 'CUS') => {
  const stopLegPairs =
    allStopLegPairs.filter((stopLegPair) => stopLegPair.stop.type === stopType)
  const withAvailableRegularStatuses =
    stopLegPairs.filter((stopLegPair) => stopLegPair.stop.availableRegularStatuses.length > 0)
  const withAvailableDiscrepancyStatuses =
    stopLegPairs.filter((stopLegPair) => stopLegPair.stop.availableDiscrepancyStatuses.length > 0)
  const forScdBulkDocumentsUpload =
    stopLegPairs.filter((stopLegPair) =>
      stopLegPair.stop.statuses.length > 0
      && stopLegPair.stop.availableStatuses.length === 0
      && stopLegPair.leg.workflowType === WorkflowType.SECURE_CLOUD_DEPLOYMENT
    )

  return {
    withAvailableRegularStatuses,
    withAvailableDiscrepancyStatuses,
    forScdBulkDocumentsUpload,
  }
}

export const isBulkStatusUpdateAvailable = (stopLegPairsWithAvailableRegularStatuses: StopLegPair[]) =>
  stopLegPairsWithAvailableRegularStatuses.length > 0

export const isScdBulkDocumentsUploadAvailable = (stopLegPairsWithAvailableRegularStatuses: StopLegPair[], stopLegPairsForScdBulkDocumentsUpload: StopLegPair[]) =>
  stopLegPairsWithAvailableRegularStatuses.length === 0 && stopLegPairsForScdBulkDocumentsUpload.length > 0
